import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common from "./locales/en/common.json";
import settings from "./locales/en/settings.json";

let initialized = false;

/**
 * Initializes the shared i18next singleton with the English resources. Safe
 * to call more than once (idempotent) — used both by the real app boot
 * (index.ts, which also wires live language switching) and by
 * setupTests.ts, so components using useTranslation() render actual English
 * text under Jest instead of falling back to raw translation keys.
 *
 * Deliberately has NO dependency on settings/settingsStore: that module
 * transitively imports settings/registry.ts, whose require.context() call
 * only works under webpack, not Jest — see schema.ts's header comment for
 * the same constraint elsewhere.
 */
export function initI18n(): typeof i18n {
  if (!initialized) {
    i18n.use(initReactI18next).init({
      resources: { en: { common, settings } },
      lng: "en",
      fallbackLng: "en",
      defaultNS: "common",
      interpolation: { escapeValue: false },
    });
    initialized = true;
  }
  return i18n;
}
